export type Locale = "es" | "en";

const STORAGE_KEY = "bpal_locale";

export const getStoredLocale = (): Locale => {
  if (typeof window === "undefined") return "es";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === "es" || stored === "en") return stored;
  const browser = window.navigator.language.toLowerCase();
  return browser.startsWith("es") ? "es" : "en";
};

export const setStoredLocale = (locale: Locale) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, locale);
};

export type Translation = {
  es: string;
  en: string;
};

export const tStatic = (value: Translation, locale?: Locale) => {
  const current = locale || getStoredLocale();
  return value[current] || value.en;
};
